__turbopack_context__.v({
  "badgeInEntityHero": "entityListItem-module-scss-module__HdsmAW__badgeInEntityHero",
  "bottomMargin": "entityListItem-module-scss-module__HdsmAW__bottomMargin",
  "contentWrapper": "entityListItem-module-scss-module__HdsmAW__contentWrapper",
  "doubleLineTitleStyles": "entityListItem-module-scss-module__HdsmAW__doubleLineTitleStyles",
  "eyebrowAndBadgeWrapper": "entityListItem-module-scss-module__HdsmAW__eyebrowAndBadgeWrapper",
  "eyebrowStyles": "entityListItem-module-scss-module__HdsmAW__eyebrowStyles",
  "imageWrapper": "entityListItem-module-scss-module__HdsmAW__imageWrapper",
  "lightTheme": "entityListItem-module-scss-module__HdsmAW__lightTheme",
  "linkStyles": "entityListItem-module-scss-module__HdsmAW__linkStyles",
  "shortDescriptionStyles": "entityListItem-module-scss-module__HdsmAW__shortDescriptionStyles",
  "smallVariant": "entityListItem-module-scss-module__HdsmAW__smallVariant",
  "textWrapperStyles": "entityListItem-module-scss-module__HdsmAW__textWrapperStyles",
  "titleStyles": "entityListItem-module-scss-module__HdsmAW__titleStyles",
});
